export default {
  clickToUpload: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500076F","点击上传") /* "点击上传" */,
  imgTips: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000770","仅支持jpg、jpeg、png、bmp格式，文件小于500KB(推荐最佳尺寸144*54px)") /* "仅支持jpg、jpeg、png、bmp格式，文件小于500KB(推荐最佳尺寸144*54px)" */
};
